import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';


/* global customElements */
class ImportGrid extends BaseComponent {
	
	static get properties() {
		return {
			admin: {type: Boolean},
			widgetmode: {type: Boolean}
		};
	}
	
	constructor() {
		super();
		
		this.admin = false;
		this.widgetmode = false;
		
		var importGrid = this;
		setTimeout(function(){
			importGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var importGrid = this;
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [				
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterCompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;' + (importGrid.admin ? '' : 'display: none;'),
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					postinit: function(combo) {
						if (importGrid.admin) {
							Service.getCompanyService().getCompaniesLookup().then(function(data){
								combo.items = data;
							});
						}
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							if (importGrid.admin) {								
								var selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
							}
							actionRefresh();
						}
					}					
				},
				{
					tag: 'vaadin-combo-box',
					itemid: 'filterDataTypeCB',
					'class': 'spacer-toolbar-item',
					name: 'dataType',
					label: 'Data Type',
					'item-value-path': 'code',
					'item-label-path': 'description',
					postinit: function (combo) {
						Service.getLookupService().getLookupValues('DataType').then(function (data) {
							combo.items = data;
						});
					},
					listeners: {
						change: function() {
							actionRefresh();
						}
					},
					placeHolder: 'Select'
				},
				{
					tag: 'vaadin-combo-box',
					itemid: 'filterDataHandlerCB',
					'class': 'spacer-toolbar-item',
					name: 'dataHandler',
					label: 'Data Handler',
					'item-value-path': 'handlerId',
					'item-label-path': 'description',
					postinit: function (combo) {
						if (importGrid.admin) {
							DataManagementService.getDataHandlerService().getDataHandlers().then(function(data) {
								combo.items = data;
							});							
						} else {
							DataManagementService.getDataHandlerService().getCompanyDataHandler().then(function(data) {
								combo.items = data;
							});
						}
					},
					listeners: {
						change: function() {
							actionRefresh();
						}
					},					
					placeHolder: 'Select'
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterField',
					'class': 'spacer-toolbar-item',
					label: 'Filter By',
					'item-value-path': 'code',
					'item-label-path': 'description',
					style: 'width: 12em;',
					value: 'originalFileName',
					postinit: function(combo) {						
						combo.items = [
							{ code: 'originalFileName', description: 'Original File Name' },
							{ code: 'transmissionType', description: 'Transmission Type' },
							{ code: 'status', description: 'Status' }
						];
					},
					listeners: {
						change: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					label: 'Filter Value',
					clearButtonVisible: true,
					style: 'width: 14em;',
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
						},
						change: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterStartDate',
					label: 'Filter Start Date',												
					name: 'filterStartDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.startCurrentMonth());	
					}()
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterEndDate',
					label: 'Filter End Date',												
					name: 'filterEndDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.endCurrentMonth());	
					}()
				}
			]
		});
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					itemId: 'mainToolSeparator-refresh',
					innerHTML: '|'
				},
				{
					tag: 'vaadin-button',
					itemid: 'details',
					'class': 'spacer-toolbar-item',
					disabled: true,
					children:[
						ElementUtil.makeIcon('vaadin:list', ' Details')
					], 
					listeners: {
						click: function() {
							actionViewDetails(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'download',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_IMPORTS:READ', 'IMPORTS:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:download', ' Download')						
					],
					listeners: {
						click: function() {
							actionDownload(grid.selectedItems);
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'downloadCombine',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_IMPORTS:READ', 'IMPORTS:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:download', ' Download Combined')						
					],
					listeners: {
						click: function() {
							actionDownloadCombine(grid.selectedItems);
						}
					}				
				},
				{
					tag: 'span',
					itemId: 'mainToolSeparator',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'reprocess',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_IMPORTS:WRITE', 'IMPORTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:arrow-circle-right', ' Re-Process')						
					],
					listeners: {
						click: function() {
							actionReprocess(grid.selectedItems);
						}
					}					
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[						
						{
							tag: 'dl-action-button',
							itemid: 'rollback',
							theme: 'error primary',					
							permissions: ['ADMIN_IMPORTS:DELETE', 'IMPORTS:DELETE'],
							'class': 'spacer-toolbar-item',	
							disabled: true,
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' RollBack')
							],
							listeners: {
								click: function() {
									actionRollback(grid.selectedItems[0]);
								}
							}
						}
					]
				}		
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-width': true,
					'auto-select': true,
					listeners: {						
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},				
				{						
					path: 'uploadBatchId',
					header: 'Upload Batch Id',
					width: '7em'
				},
				{						
					path: 'dataTypeDescription',
					header: 'Data Type',
					width: '7em'
				},
				{						
					path: 'dataHandlerDescription',
					header: 'Data Handler',
					width: '7em'
				},	
				{						
					path: 'dataBeginDate',
					header: 'Data Begin Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						if (rowData.item.dataBeginDate) {
							var date = TimeUtil.parseDate(rowData.item.dataBeginDate);						
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						} else {
							root.innerHTML = 'N/A';						
						}
					}
				},
				{						
					path: 'dataEndDate',
					header: 'Data End Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						if (rowData.item.dataEndDate) {
							var date = TimeUtil.parseDate(rowData.item.dataEndDate);						
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						} else {
							root.innerHTML = 'N/A';
						}
					}
				},				
				{						
					path: 'originalFileName',
					header: 'Original File Name',
					width: '9em'
				},												
				{						
					path: 'status',
					header: 'Status',
					width: '5em',
					renderer: function(root, column, rowData) {
						if (rowData.item.status === 'PENDING') {
							root.style.backgroundColor = '#848484';
						} else if (rowData.item.status === 'NOT_PROCESSED') {
							root.style.backgroundColor = 'beige';
						} else if (rowData.item.status === 'REPROCESING') {
							root.style.backgroundColor = '#5884ab';
						} else if (rowData.item.status === 'ERRORS') {							
							root.style.backgroundColor = '#a36f6f';
						} else if (rowData.item.status === 'WARNINGS') {
							root.style.backgroundColor = '#878713';
						} else if (rowData.item.status === 'WORKING') {
							root.style.backgroundColor = 'lightgreen';
						} else if (rowData.item.status === 'CANCELED') {
							root.style.backgroundColor = 'lightsteelblue';						
						} else if (rowData.item.status === 'ROLLINGBACK') {
							root.style.backgroundColor = '#d68a00';
						} else {
							root.style.backgroundColor = '';
						}
						root.innerHTML = rowData.item.statusDescription;
					}
				},
				{
					path: 'createDts',
					header: 'Upload Date',
					'text-align': 'center',
					width: '5em',
					renderer: function(root, column, rowData)  {
						if (rowData.item.createDts) {
							var date = TimeUtil.parseDate(rowData.item.createDts);						
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						} else {
							root.innerHTML = 'N/A';						
						}
					}
				},
				{
					path: 'transmissionType',
					header: 'Transmission Type',
					'text-align': 'center',
					width: '7em',
					renderer: function(root, column, rowData)  {
						if (rowData.item.transmissionType) {								
							root.innerHTML = rowData.item.transmissionType;					
						} else {
							root.innerHTML = 'Manual Upload';						
						}
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
		
		var gridSelectionChange = function() {
			//delay for the check box
			setTimeout(function(){					
				if (grid.selectedItems.length === 1) {					  
					ElementUtil.query(toolbar, 'details').disabled = false;
					ElementUtil.query(toolbar, 'download').disabled = false;
					ElementUtil.query(toolbar, 'downloadCombine').disabled = true;
					ElementUtil.query(toolbar, 'reprocess').disabled = false;

					if (grid.selectedItems[0].rollbackSupported) {
						ElementUtil.query(toolbar, 'rollback').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'rollback').disabled = true;
					}
				} else if (grid.selectedItems.length > 0) {	
					ElementUtil.query(toolbar, 'details').disabled = true;
					ElementUtil.query(toolbar, 'download').disabled = false;
					ElementUtil.query(toolbar, 'reprocess').disabled = false;
					
					var allSameHandler = true;
					var previousHandler;
					grid.selectedItems.forEach(function(item){
						if (previousHandler && item.dataHandlerId !== previousHandler) {
							allSameHandler = false;
						} else {
							previousHandler = item.dataHandlerId;
						}
					});
					
					if (allSameHandler) {
						ElementUtil.query(toolbar, 'downloadCombine').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'downloadCombine').disabled = true;
					}
					ElementUtil.query(toolbar, 'rollback').disabled = true;						
				} else {						
					ElementUtil.query(toolbar, 'details').disabled = true;
					ElementUtil.query(toolbar, 'download').disabled = true; 
					ElementUtil.query(toolbar, 'downloadCombine').disabled = true; 
					ElementUtil.query(toolbar, 'reprocess').disabled = true; 
					ElementUtil.query(toolbar, 'rollback').disabled = true; 
				}
							
			});
		};		
			
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			pageSize: 50,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
										
						var selectedCompany = null;
						if (importGrid.admin) {
							selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
							
							if (!selectedCompany) {
								loadMask.remove();
								window.DL.MessageUtil.showToast('Validation', 'Select a company first.', {									
										theme: 'error'
								});
								return;
							}
						}
						
						var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterStartDate').value);										
						var endFilterDts =  TimeUtil.endOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterEndDate').value);		
												
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'createDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'DESC',
							start: startFilterDts,
							end: endFilterDts,							
							dateField: 'createDts'
						};
						
						var filterDataType = ElementUtil.query(toolbarFilter, 'filterDataTypeCB').value;
						if (filterDataType) {							
							grid.currentFilter.dataType = filterDataType;
						}
						
						var filterDataHandler = ElementUtil.query(toolbarFilter, 'filterDataHandlerCB').value;
						if (filterDataHandler) {							
							grid.currentFilter.dataHandlerId = filterDataHandler;
						}

						var filterField = ElementUtil.query(toolbarFilter, 'filterField').value;
						var filterValue = ElementUtil.query(toolbarFilter, 'filterValue').value;
						if (filterField && filterValue) {
							grid.currentFilter.filterField = filterField;
							grid.currentFilter.filterValue = filterValue;
						}
						
						if (selectedCompany) {
							grid.currentFilter.companyId = selectedCompany;
						}						
					
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;						
							grid.items = records.data;
							grid.selectedItems = [];
							gridSelectionChange();

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();							
						};
						
						DataManagementService.getImportService().getImports(grid.currentFilter).then(function(records){
							successHandler(records);
						});						
					};	
					
					loadData();
														
				};
			},
			listeners: {
				ready: function() {		
					if (!importGrid.admin) {
						pagingToolbar.loadCurrentPage();					
					}
				}
			}
			
		});			
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				var exportFilter = Object.assign({}, grid.currentFilter || {});
				delete exportFilter.offset;
				delete exportFilter.max;
				DataManagementService.getImportService().exportImports(exportFilter);
			}
		});
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		importGrid.append(flexLayout);		
		
		if (importGrid.widgetmode) {
			setTimeout(function(){
				ElementUtil.query(toolbar, 'details').classList.add('hide');
				ElementUtil.query(toolbar, 'download').classList.add('hide');
				ElementUtil.query(toolbar, 'downloadCombine').classList.add('hide');
				ElementUtil.query(toolbar, 'reprocess').classList.add('hide');
				ElementUtil.query(toolbar, 'rollback').classList.add('hide');
				ElementUtil.query(toolbar, 'mainToolSeparator').classList.add('hide');
				ElementUtil.query(toolbar, 'mainToolSeparator-refresh').classList.add('hide');
				toolbarFilter.classList.add('hide');
			});
		}		
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};

		attachWorkspaceFilterState(importGrid, toolbarFilter, ['filterCompany','filterDataTypeCB','filterDataHandlerCB','filterField','filterValue','filterStartDate','filterEndDate'], actionRefresh);
	
		var actionViewDetails = function(record) {
			var detailWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Details',
				icon: 'vaadin:modal-list',
				width: .75,
				height: .75,
				listeners: {
					ready: function() {
						detailWin.show();
						
						var detailTable = ElementUtil.create({
							tag: 'dl-detail-table',
							itemid: 'detailtable',
							slot: 'primary'
						});
						
						var updateDetails = function(detail) {
							var data = [
								{
									key: 'Import',
									value: '-',
									section: true
								},			
								{
									key: 'Import Id',
									value: detail.importHistory.uploadBatchId
								},
								{
									key: 'Status',
									value: '<b>' + detail.importHistory.statusDescription + '</b>'
								},
								{
									key: 'Data Type',
									value: detail.importHistory.dataTypeDescription
								},
								{
									key: 'Data Handler',
									value: detail.importHistory.dataHandlerDescription
								},
								{
									key: 'Data Handler',
									value: detail.importHistory.transmissionType ? detail.importHistory.transmissionType : 'Manual Upload'
								},
								{
									key: 'Data Start Date',
									value: detail.importHistory.dataBeginDate ? TimeUtil.formatDateStandard(detail.importHistory.dataBeginDate) : "N/A"
								},
								{
									key: 'Data End Date',
									value: detail.importHistory.dataEndDate ? TimeUtil.formatDateStandard(detail.importHistory.dataEndDate) : "N/A"  
								},
								{
									key: 'File Data Min Date',
									value: detail.importHistory.fileMinDataDate ? TimeUtil.formatDateStandard(detail.importHistory.fileMinDataDate) : "N/A"
								},
								{
									key: 'File Data Max Date',
									value: detail.importHistory.fileMaxDataDate ? TimeUtil.formatDateStandard(detail.importHistory.fileMaxDataDate) : "N/A"  
								},								
								{
									key: 'Content Type',
									value: detail.importHistory.contentType
								},
								{
									key: 'Original Filename',
									value: detail.importHistory.originalFileName
								},
								{
									key: 'Stored Name',
									value: detail.importHistory.savedFileName
								},
								{
									key: 'Start Date',
									value: detail.importHistory.startDate ? TimeUtil.formatDateStandard(detail.importHistory.startDate) : "Not Started"  
								},
								{
									key: 'Complete Date',
									value: detail.importHistory.completeDate ? TimeUtil.formatDateStandard(detail.importHistory.completeDate) : ""  
								},								
								{
									key: 'Last Reprocessed Date',
									value: detail.importHistory.lastReprocessedDate ? TimeUtil.formatDateStandard(detail.importHistory.lastReprocessedDate) : "Has not been Reprocessed"  
								},
								{
									key: 'Expired Date',
									value: detail.importHistory.expireDate ? TimeUtil.formatDateStandard(detail.importHistory.expireDate) : "No Expiration Date"  
								},
								{
									key: 'Create User',
									value: detail.importHistory.createUser
								},
								{
									key: 'Upload Date',
									value: TimeUtil.formatDateStandard(detail.importHistory.createDts)
								},
								{
									key: 'Update User',
									value: detail.importHistory.updateUser
								},
								{
									key: 'Last Update Date',
									value: TimeUtil.formatDateStandard(detail.importHistory.updateDts)
								},
								{
									key: 'Rollback Support',
									value: detail.importHistory.rollbackSupported									
								},
								{
									key: 'Stats',
									value: '-',
									section: true
								},
								{
									key: 'Total Records',
									value: (detail.importHistory.stats.totalRecords ? detail.importHistory.stats.totalRecords : 0)
								},
								{
									key: 'Usable Records',
									value: (detail.importHistory.stats.usableRecords ? detail.importHistory.stats.usableRecords : 0)
								},
								{
									key: 'Stored Records',
									value: (detail.importHistory.stats.storeRecords ? detail.importHistory.stats.storeRecords : 0)
								},
								{
									key: 'Filtered Records',
									value: (detail.importHistory.stats.filteredRecords ? detail.importHistory.stats.filteredRecords : 0)
								},
								{
									key: 'Total Errors',
									value: (detail.importHistory.stats.totalErrors ? detail.importHistory.stats.totalErrors : 0)
								},
								{
									key: 'Total Warnings',
									value: (detail.importHistory.stats.totalWarnings ? detail.importHistory.stats.totalWarnings : 0)
								},
								{
									key: 'Matched Units',
									value: (detail.importHistory.stats.matchedUnits ? detail.importHistory.stats.matchedUnits : 0)
								},
								{
									key: 'Unmatched Unit',
									value: (detail.importHistory.stats.unMatchedUnits ? detail.importHistory.stats.unMatchedUnits : 0)
								}				
							];						

							if (detail.importHistory.options) {
								data.push({
									key: 'Advanced Options',
									value: '-',
									section: true
								});
								
								if (detail.importHistory.options) {									
									for (var key in detail.importHistory.options) {										
										if (key === 'properties') {
											var properties = detail.importHistory.options[key];
											if (properties) {
												var allProps = [];
												for (var propKey in properties) {
													allProps.push(propKey + '=' + properties[propKey]);
												}
												
												data.push({
													key: key,
													value: allProps.join(' | ')
												});
											}
										} else {
											data.push({
												key: key,
												value: (detail.importHistory.options[key] ? detail.importHistory.options[key] : '') 
											});
										}
									}
								}
							}							

							detailTable.updateDetails(data);
							
							//update error grid
							errorsGrid.items = detail.details;							
						};
						
						var detailedLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [							
								detailTable
							]
						});	
	
						var errorsGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',			
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},			
							children: [
								{
									tag: 'vaadin-grid-column',
									'flex-grow': '0',
									width: '50px',					
									renderer: function(root, column, rowData) {
										var expander = ElementUtil.create({
											tag: 'span',
											'class': 'grid-expander',
											trustedInnerHTML: true,
											innerHTML: '<b>+</b>',
											properties: {
												expanded: false
											},
											listeners: {
												click: function() {
													if (expander.expanded) {
														expander.innerHTML = '<b>+</b>';
														expander.expanded = false;
														errorsGrid.closeItemDetails(root.item);
													} else {
														expander.innerHTML = '<b>-</b>';
														expander.expanded = true;
														errorsGrid.openItemDetails(root.item);
													}
												}
											}
										});
										//this must be set for expand to open
										root.item = rowData.item;
										if (!root.firstElementChild) {
											root.append(expander);
										}
									}
								},								
								{						
									path: 'messageType',
									header: 'Type',
									width: '7em'
								},
								{						
									path: 'logLevel',
									header: 'Level',
									width: '7em'
								},
								{						
									path: 'recordId',
									header: 'Record Id',
									width: '7em'
								},
								{						
									path: 'message',
									header: 'Message',
									width: '12em'
								}
							]
						});
						
						errorsGrid.rowDetailsRenderer = function (root, grid, rowData) {
							if (!root.firstElementChild) {
								root.innerHTML = '<div style="border: 1px solid"><div style="padding: 5px;">' +
										rowData.item.message + '<br><br>' +
										(rowData.item.trace ? StringUtil.newLineToHTML(rowData.item.trace) : '(No Additional Detail)') +
										'</div></div>';
							}
						};	
						
						var errorFooter = ExportUtil.createExportFooter({
							grid: errorsGrid,
							itemid: 'import-errors',
							showDetail: false
						});

						var errorLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								errorsGrid,
								errorFooter.footerContainer
							]
						});
	
						//search
						var unitToolbarFilter = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'vaadin-combo-box',
									itemid: 'filterType',
									'class': 'spacer-toolbar-item',
									'keep-open': true,
									style: 'width: 250px;',
									label: 'Filter By',
									'item-value-path': 'code',
									'item-label-path': 'description',
									required: true,
									value: 'unitRefNo',
									postinit: function (combo) {
										var lookups = [
											{
												code: 'unitMatchedId',
												description: 'Unit Match Id'
											},																						
											{
												code: 'unitRefNo',
												description: 'Reference No'
											}
										];
										combo.items = lookups;
									},
									placeHolder: 'Select'
								},
								{
									tag: 'vaadin-text-field',
									itemid: 'filterValue',
									'class': 'spacer-toolbar-item',
									'keep-open': true,
									label: 'Filter Value',
									listeners: {
										input: {
											fn: function () {
												actionUnitRefresh();
											},
											buffer: 2000
										}
									}
								},
								{
									tag: 'div',
									innerHTML: 'Units details will expire according to retention policy'
								}
							]
						});							
	
						var unitsGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',			
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},			
							children: [
								{						
									path: 'referenceType',
									header: 'Reference Type',
									width: '7em'
								},
								{						
									path: 'unitRefNo',
									header: 'Unit Reference No',
									width: '7em'
								},
								{						
									path: 'unitMatchedId',
									header: 'Unit Matched Id',
									width: '7em'
								},
								{						
									path: 'resolutionDescription',
									header: 'Resolution',
									width: '7em'
								},
								{
									path: 'beginDate',
									header: 'Data Begin Date',
									width: '7em',
									renderer: function (root, column, rowData) {
										if (rowData.item.beginDate) {
											var date = TimeUtil.parseDate(rowData.item.beginDate);
											root.innerHTML = TimeUtil.formatDateStandard(date);
										} else {
											root.innerHTML = 'N/A';
										}
									}
								},
								{
									path: 'endDate',
									header: 'Data End Date',
									width: '7em',
									renderer: function (root, column, rowData) {
										if (rowData.item.endDate) {
											var date = TimeUtil.parseDate(rowData.item.endDate);
											root.innerHTML = TimeUtil.formatDateStandard(date);
										} else {
											root.innerHTML = 'N/A';
										}
									}
								}
							]
						});
						
						var unitPagingToolbar = ElementUtil.create({
							tag: 'dl-paging-toolbar',
							slot: 'footer',
							pageSize: 50,
							postinit: function(element) {
								element.grid = unitsGrid;
								element.loader = function(backingGrid, pageNumber, pagebar) {
									var pageRange = pagebar.pullRange();
									var loadMask = unitsGrid.showLoading();

									var loadData = function() {

										unitsGrid.currentFilter = {
											offset: pageRange.offset,
											max: pageRange.max,
											sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'updateDts',
											sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC'
										};											
										
										if (importGrid.admin) {
											var selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
											unitsGrid.currentFilter.companyId = selectedCompany;
										}	
										
										var filterType = ElementUtil.query(unitToolbarFilter, 'filterType').value;
										var filterValue = ElementUtil.query(unitToolbarFilter, 'filterValue').value;
										if (filterType && filterValue) {
											unitsGrid.currentFilter.filterField = filterType;
											unitsGrid.currentFilter.filterValue = filterValue;
										}

										var successHandler = function(records) {
											loadMask.remove();
											unitsGrid.activeItem = null;						
											unitsGrid.items = records.data;

											unitPagingToolbar.totalRecords = records.totalNumber;
											unitPagingToolbar.updatePager();						
										};

										DataManagementService.getImportService().getImportUnits(record.uploadBatchId, unitsGrid.currentFilter).then(function(records){
											successHandler(records);
										});						
									};	

									loadData();
								};
							},
							listeners: {
								ready: function() {					
									unitPagingToolbar.loadCurrentPage();					
								}
							}

						});						

						var unitFooter = ExportUtil.createExportFooter({
							pagingToolbar: unitPagingToolbar,
							grid: unitsGrid,
							itemid: 'import-units',
							onDetail: function() {
								var exportFilter = Object.assign({}, unitsGrid.currentFilter || {});
								delete exportFilter.offset;
								delete exportFilter.max;
								DataManagementService.getImportService().exportImportUnits(record.uploadBatchId, exportFilter);
							}
						});

						var unitLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [		
								unitToolbarFilter,
								unitsGrid,
								unitFooter.footerContainer
							]
						});			
						
						var actionUnitRefresh = function() {
							unitPagingToolbar.loadPage(1);
						};
						
						var tabPanel = ElementUtil.create({
							tag: 'dl-tabpanel',
							listeners: {
								ready: function(e) {									
									tabPanel.addTabs([
										{
											'tab-title': 'Summary',
											tag: 'div',
											style: 'height: 100%;',
											children: [														
												detailedLayout												
											]
										},
										{
											'tab-title': 'Errors / Messages',
											tag: 'div',
											style: 'height: 100%;',
											children: [		
												errorLayout
											]
										},
										{
											'tab-title': 'Units',
											tag: 'div',
											style: 'height: 100%;',
											children: [		
												unitLayout
											]
										}										
									]);
								}
							}
						});						
						detailWin.addToContentElement(tabPanel);						
						
						//pull Details
						var selectedCompany = null;
						if (importGrid.admin) {		
							selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
						}						
						DataManagementService.getImportService().getImportDetails(record.uploadBatchId, selectedCompany).then(function(detail){
							updateDetails(detail);
						});
						
					}
				}
			});
			
		};	
	
		var actionDownload = function(records) {
			var ids = [];			
			records.forEach(function(record){
				ids.push(record.uploadBatchId);
			});			
			
			var selectedCompany = null;
			if (importGrid.admin) {
				selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
			}				
			DataManagementService.getImportService().downloadImport(ids.join(','), selectedCompany);			
		};
		
		var actionDownloadCombine = function(records) {
			var ids = [];			
			records.forEach(function(record){
				ids.push(record.uploadBatchId);
			});			
			
			var selectedCompany = null;
			if (importGrid.admin) {
				selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
			}				
			DataManagementService.getImportService().downloadImportCombine(ids.join(','), selectedCompany);			
		};		
		
		var openReprocessDialog = function(records, savedOptions, optionsDiffer) {
			var dialogTitle = records.length === 1
				? 'Re-Process'
				: 'Re-Process (' + records.length + ' files)';

			var reprocessWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: dialogTitle,
				icon: 'vaadin:arrow-circle-right',
				width: .75,
				height: .75,
				listeners: {
					ready: function() {
						reprocessWin.show();
						
						var formChildren = [];
						var includesGpsImport = ImportUtil.selectionIncludesGpsImport(records);
						if (records.length > 1) {
							var multiFileMessage = 'Advanced options below will be applied to each of the ' + records.length + ' selected files.';
							if (includesGpsImport) {
								multiFileMessage += ' GPS filtering applies only to GPS Files';
							}
							if (optionsDiffer) {
								multiFileMessage += ' Selected imports used different saved options; values shown are from the first file.';
							}
							formChildren.push({
								tag: 'div',
								'class': 'alert alert-info',
								innerHTML: multiFileMessage
							});
						}
						formChildren.push({
							tag: 'fieldset',				
							children: [
								{
									tag: 'legend',
									innerHTML: 'Advanced Options'
								},
								{
									tag: 'dl-import-option-form',
									properties: {
										showGPSFilter: includesGpsImport,
										savedOptions: savedOptions
									}
								}
							]
						});
						formChildren.push({
							tag: 'vaadin-form-layout',
							children: [										
								{
									tag: 'hr',
									colspan: 2
								},
								{
									tag: 'div',
									style: 'text-align: center;',
									colspan: 2,
									defaults: {
										tag: 'vaadin-button'
									},
									children: [
										{
											theme: 'primary',
											children: [
												ElementUtil.makeIcon('vaadin:upload', ' Reprocess')
											],
											listeners: {
												click: function () {
													formPanel.submitForm({
														maskMessage: records.length === 1
															? 'Submitting...'
															: 'Submitting ' + records.length + ' files...',
														preSubmit: function (data) {														
															return data;
														},
														actualCall: function (data) {
															var importService = DataManagementService.getImportService();
															var submittedCount = 0;
															var chain = Promise.resolve();
															records.forEach(function(record) {
																chain = chain.then(function() {
																	var reprocessOptions = ImportUtil.buildReprocessOptions(data, record);
																	return importService.reprocess(record.uploadBatchId, record.companyId, reprocessOptions).then(function(response) {
																		if (!response || response.success === false) {
																			var failure = response || { success: false };
																			failure.submittedCount = submittedCount;
																			failure.failedFileName = record.originalFileName || record.uploadBatchId;
																			return Promise.reject(failure);
																		}
																		submittedCount++;
																		response.submittedCount = submittedCount;
																		return response;
																	}).catch(function(error) {
																		if (error && typeof error === 'object') {
																			error.submittedCount = submittedCount;
																			if (!error.failedFileName) {
																				error.failedFileName = record.originalFileName || record.uploadBatchId;
																			}
																		}
																		return Promise.reject(error);
																	});
																});
															});
															return chain;
														},
														success: function (data, responseData) {
															var successMessage = records.length === 1
																? 'Submitted Import for Reprocessing'
																: 'Submitted ' + records.length + ' Imports for Reprocessing';
															window.DL.MessageUtil.showToast('Success', successMessage, {
																theme: 'success',
																position: 'top-stretch'
															});
															actionRefresh();
															reprocessWin.close();
														},
														fail: function (data, failedResponse) {
															var submittedCount = failedResponse && failedResponse.submittedCount ? failedResponse.submittedCount : 0;
															if (submittedCount > 0) {
																window.DL.MessageUtil.showToast(
																	'Partial Success',
																	'Submitted ' + submittedCount + ' of ' + records.length
																		+ ' imports before failing on '
																		+ (failedResponse.failedFileName || 'a selected file') + '.',
																	{
																		theme: 'warning',
																		position: 'top-stretch'
																	}
																);
																actionRefresh();
															}
														}
													});
												}
											}
										},
										{
											theme: 'tertiary',
											innerHTML: 'Cancel',
											style: 'margin-left: 10px;',
											listeners: {
												click: function () {
													reprocessWin.close();
												}
											}
										}
									]
								}
							]
						});

						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: formChildren
						});
						reprocessWin.addToContentElement(formPanel);

					}
				}
			});
		};

		var actionReprocess = function(records) {
			if (!records || records.length === 0) {
				return;
			}

			var resolved = ImportUtil.resolveReprocessSavedOptions(records);
			if (records.length === 1 && !resolved.options) {
				var selectedCompany = null;
				if (importGrid.admin) {
					selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
				}
				DataManagementService.getImportService().getImportDetails(
					records[0].uploadBatchId,
					selectedCompany
				).then(function(detail) {
					var options = detail && detail.importHistory && detail.importHistory.options
						? detail.importHistory.options
						: null;
					openReprocessDialog(records, options, false);
				});
				return;
			}

			openReprocessDialog(records, resolved.options, resolved.optionsDiffer);
		};
	
		var actionRollback = function(record) {
			var rollbackWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Rollback - ' + record.originalFileName,
				icon: 'vaadin:trash',
				width: .75,
				height: 300,
				listeners: {
					ready: function() {
						rollbackWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'div',
									'class': 'alert alert-warning',										
									trustedInnerHTML: true,
									innerHTML: '<i class="fas fa-2x fa-exclamation-triangle"></i><b>This will submit a task to remove all data load from this file and remove this record.</b>'
								},
								{
									tag: 'vaadin-form-layout',										
									children: [										
										{
											tag: 'vaadin-checkbox',
											name: 'continueOnLock',
											label: 'Continue On Lock'										
										},										
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Rollback')
													],
													listeners: {
														click: function() {															
															
															var data = formPanel.getData();
															
															var selectedCompany = null;
															if (importGrid.admin) {
																selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
															}		
														
															DataManagementService.getImportService().rollbackImport(record.uploadBatchId, selectedCompany, data.continueOnLock).then(function(results) {
																window.DL.MessageUtil.showToast('Success', 'Submitted file for Rollback', {
																	theme: 'success',
																	position: 'top-stretch'
																});
																rollbackWin.close();
															});
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															rollbackWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						rollbackWin.addToContentElement(formPanel);
						
					}
				}
			});
		};		
				
	}

}
customElements.define('dl-import-grid', ImportGrid);
